import { nanoid } from 'nanoid'
import i18n from '@/plugins/vue-i18n'
import alertTypes from '@/constants/alerts/alertTypes'
import alertIds from '@/constants/alerts/alertIds'

export default class AlertDTO {
  constructor(config = {}) {
    this.id = config.id
    this.type = config.type || alertTypes.ACTION

    this.title = config.title || ''
    this.dismissible = config.dismissible || true
    this.dismissText = config.dismissText || i18n.t('general.dismissBtn')
    this.showActions = config.showActions || true

    this.autoDismiss = config.autoDismiss || false
    this.autoDismissDelay = config.autoDismissDelay || 5000

    this.priority = config.priority || 0
    this.timestamp = config.timestamp || Date.now() // used to break ties in the queue

    /**
     * @type {Array<AlertAction>}
     */
    this.actions =
      config?.actions?.map((action) => new AlertAction(action)) || []
  }
}

class AlertAction {
  constructor({ text = '', action = null, form = null } = {}) {
    this.id = nanoid()
    this.text = text
    /**
     * Function to execute
     * @type {Function|null}
     */
    this.action = action
    /**
     * Form object for form-based actions
     * @type {FormDTO|null}
     */
    this.form = form
  }

  get actionType() {
    return this.form ? alertIds.FORM : null
  }
}
